import greekUtils from 'greek-utils';
const matchSearchString = (searchTerm,text) => {
    text = greekUtils.toGreeklish(text);
    searchTerm = greekUtils.toGreeklish(searchTerm);
    return (
        text.normalize("NFD").replace(/[\u0300-\u036f]|’/g, "").indexOf(searchTerm) !== -1
        ||
        text.normalize("NFD").replace(/[\u0300-\u036f]|’/g, "").toLowerCase().indexOf(searchTerm.toLowerCase()) !== -1
    )
}

export default matchSearchString;
